<template>
  <div>
    <!-- {{moduleId}} -->
    <b-table
      ref="MyForm"
      class="table-nowrap"
      :busy.sync="isBusy"
      :items="myProvider"
      :fields="fields"
      :filter="tableFilters"
      :filter-debounce="500"
      :per-page="tablePerPage"
      :current-page="tableCurrentPage"
    >
      <template slot="thead-top" slot-scope="{ fields }">
        <b-tr>
          <b-th v-for="field in fields" :key="field.key">
            <div v-if="tableFilters[field.filterKey] != null">
              <b-form-select
                v-if="field.filterKey == 'formActive'"
                :options="optionsBoolean"
                v-model="tableFilters[field.filterKey]"
              >
              </b-form-select>
              <b-form-input
                v-else
                v-model="tableFilters[field.filterKey]"
                :placeholder="'Buscar por ' + field.label"
              />
            </div>
          </b-th>
        </b-tr>
      </template>
      <template v-slot:cell(id)="data">
        <b-col v-if="data.item.ativo" class="buttons">
          <div v-if="$store.getters.isChecklistFormEdit == true">
            <router-link
              v-if="data.item.profileEdit == true"
              class="desktop-buttons"
              :to="'/checklist/Layout/form/EditForm/' + data.value"
            >
              <b-button size="sm">{{ $t("checklist.form.edit") }}</b-button>
            </router-link>
            <b-button v-else size="sm" disabled>{{
              $t("checklist.form.edit")
            }}</b-button>
          </div>
          <!-- {{ data.value }} -->
          <router-link
            v-if="$store.getters.isChecklistFormCreator == true"
            class="desktop-buttons"
            :to="'/checklist/Layout/form/Create/' + data.value"
          >
            <b-button v-if="$store.getters.isChecklistFormEdit" size="sm">{{
              $t("checklist.form.necklace")
            }}</b-button>
          </router-link>
          <b-button
            v-if="$store.getters.isChecklistFormDelete == true"
            class="desktop-buttons"
            size="sm"
            @click="deleteForm(data.value)"
            >{{ $t("geral.disable") }}</b-button
          >
          <router-link
            v-if="data.item.profileFill == true && moduleId == '0'"
            :to="'/checklist/Layout/form/Fill/' + data.value"
          >
            <b-button size="sm">{{ $t("checklist.sidebar.Fill") }}</b-button>
          </router-link>
          <b-button v-else-if="moduleId == '0'" size="sm" disabled>{{
            $t("checklist.sidebar.Fill")
          }}</b-button>
        </b-col>
        <b-col v-else class="buttons">
          <b-button
            v-if="data.item.profileEdit"
            class="desktop-buttons"
            size="sm"
            disabled
            >{{ $t("checklist.form.edit") }}</b-button
          >
          <router-link
            v-if="data.item.profileEdit"
            class="desktop-buttons"
            to="/checklist/Layout/form/Create/"
          >
            <b-button v-if="$store.getters.isChecklistFormEdit" size="sm">{{
              $t("checklist.form.necklace")
            }}</b-button>
          </router-link>
          <b-button
            v-if="$store.getters.isChecklistFormCreator == true"
            class="desktop-buttons"
            size="sm"
            @click="activateForm(data.value)"
            >{{ $t("geral.activate") }}</b-button
          >
          <b-button size="sm" disabled>{{
            $t("checklist.sidebar.Fill")
          }}</b-button>
        </b-col>
      </template>
      <template v-slot:cell(ativo)="data">
        {{ data.value ? "Sim" : "Não" }}
      </template>
      <template v-slot:cell(link)="data">
        <b-button size="sm" @click="openShareModal(data.item)"
          ><img src="/img/link-icon.svg" alt=""
        /></b-button>
      </template>
    </b-table>
    <b-modal
      v-model="isModalVisible"
      title="Configuração do Link de Compartilhamento"
      size="lg"
      hide-footer
    >
      <share-modal
        @close-modal="isModalVisible = false"
        :item="selectedItem"
      ></share-modal>
    </b-modal>

    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
  </div>
</template>
<script>
export default {
  name: "Own",
  components: {
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    ShareModal: () =>
      import("@/components_rms/checklist/shareForm/ShareModal.vue")
  },
  props: {
    moduleId: String
  },

  data() {
    return {
      isBusy: false,
      fields: [
        {
          key: "id",
          sortable: false,
          label: "",
          tdClass: "checklist-own-table-col-buttons"
        },
        {
          key: "nome",
          filterKey: "formName",
          sortable: true
        },
        {
          key: "ativo",
          filterKey: "formActive",
          sortable: true,
          label: "Ativo",
          tdClass: "table-col-dinamic-width"
        },
        { key: "link", label: "Link" }
      ],
      tableFilters: {
        formName: "",
        formActive: true
      },
      forms: [],
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" }
      ],
      modelstate: [],
      items: [],
      tableRows: [],
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      isModalVisible: false,
      selectedItem: null
    };
  },
  created() {
    // this.myProvider();
  },
  methods: {
    openShareModal(item) {
      this.selectedItem = item;
      this.isModalVisible = true;
    },
    myProvider(ctx) {
      console.log(ctx);
      let apiParam = {
        currentPage: this.tableCurrentPage,
        perPage: this.tablePerPage,
        formActive: ctx.filter.formActive,
        formName: ctx.filter.formName
      };
      let url = `/GetOwnByModuleId/${this.moduleId}`;
      if (this.moduleId == "0") url = `/form/own/`;
      this.isBusy = true;
      return this.$apiChecklist
        .post(url, apiParam)
        .then(response => {
          console.log(response);
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          this.items = items;
          // console.log(this.items);
          return items;
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            return [];
          }
        });
    },
    getFormsByModule(apiParam) {
      this.$apiChecklist
        .post("/GetOwnByModuleId/" + this.moduleId, apiParam)
        .then(response => {
          console.log(response);
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          this.items = items;
          console.log(items);
          return items;
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
          console.log(error);
          console.log(error.response.data.errors);

          return null;
        });
    },
    activateForm(id) {
      this.$apiChecklist
        .get("/form/activate/" + id.toString())
        .then(response => {
          this.$refs.MyForm.refresh();
          this.$refs.alert.show();
        })
        .catch(error => {
          console.log(error.response);
          this.$refs.danger.msg =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    deleteForm(id) {
      console.log("delete");
      this.$apiChecklist
        .get("/form/delete/" + id.toString())
        .then(response => {
          console.log(response.data);
          this.$refs.MyForm.refresh();
          this.$refs.alert.show();
        })
        .catch(error => {
          console.log(error.response);
          this.$refs.danger.msg =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    }
  }
};
</script>
<style>
.checklist-own-table-col-buttons {
  width: 1%;
}

.checklist-own-table-col-buttons button {
  margin-right: 5px !important;
}

.checklist-own-table-col-ativo {
  width: 80px;
}
</style>

<style scoped>
.desktop-buttons {
  display: block;
}
@media (max-width: 576px) {
  .desktop-buttons {
    display: none;
  }
}

.list {
  margin-left: 24%;
}

.buttons {
  display: flex;
  justify-content: space-evenly;
}

.buttons b-button {
  width: 50%;
}
</style>
